import { defineNuxtPlugin } from '#app';
import { DotLottiePlayer } from '@aarsteinmedia/dotlottie-player-light';

export default defineNuxtPlugin({
  name: 'dotlottie-player',
  parallel: true,
  setup(nuxtApp) {
    nuxtApp.vueApp.component('DotLottiePlayer', DotLottiePlayer);
  },
});
